export default "__VITE_ASSET__7OfTpilaaKKlAQmMY4Sl0A__";